export default "__VITE_ASSET__D$eYE17$__"